import { Injectable } from '@angular/core';

export enum GENERAL_EVENTS {
  // demoRibbonEvents
  demoTried = 'demoTried',
  demoRibbonLearnMoreClicked = 'demoRibbonLearnMoreClicked',
  demoRibbonLoginClicked = 'demoRibbonLoginClicked',
  demoRibbonSignupClicked = 'demoRibbonSignupClicked',

  // faqEvents
  faqWhyPrefundClicked = 'faqWhyPrefundClicked',
  faqIsFreeClicked = 'faqIsFreeClicked',
  faqWhySubscribeClicked = 'faqWhySubscribeClicked',
  faqReadMoreClicked = 'faqReadMoreClicked',
  faqPricingLearnMoreClicked = 'faqPricingLearnMoreClicked',

  // userEvent
  userSignup = 'userSignup',
  userLogin = 'userLogin',
  userCheckout = 'userCheckout',
  userCheckoutFailed = 'userCheckoutFaied',
  userSubscribed = 'userSubscribed',
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsLoggerService {
  constructor() {}

  logEvent(event: string) {
    try {
      // @ts-ignore
      (window.umami as any).track(event);
    } catch (e) {
      console.log(e);
      // ignore
    }
  }
}
